import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useSelector } from 'react-redux';

import {
  isAuthenticatedOrProspect,
  isProspectUser,
  isAuthenticated,
} from '../store/session/selectors';

export const query = gql`
  query SuperchargerAccount {
    me {
      id
      firstName
      phoneNumber
    }
  }
`;

// wb-user-service's placeholder name for a phone number prospect (a free
// member who hasn't told us her name).
const ANONYMOUS_FIRST_NAME = 'Anonymous';

// The signed-in account a GLP Won step prefills from (2026-10-15): a
// Supercharger free member arrives from her join link signed in, often as
// the phone number prospect her JOIN text created. firstName is null while
// it's still the "Anonymous <Animal>" placeholder. isProspect: signed in as
// a prospect, so signing up upgrades that same account (see GlpWonSignup).
export function useSuperchargerAccount() {
  const signedIn = useSelector(isAuthenticatedOrProspect);
  const prospect = useSelector(isProspectUser);
  const registered = useSelector(isAuthenticated);
  const isProspect = prospect && !registered;
  const { data, loading } = useQuery(query, { skip: !signedIn });
  const me = data?.me;

  return {
    loading: signedIn && loading,
    userId: me?.id ? Number(me.id) : null,
    firstName:
      me?.firstName && me.firstName !== ANONYMOUS_FIRST_NAME
        ? me.firstName
        : null,
    phoneNumber: me?.phoneNumber || null,
    isProspect,
  };
}
